module.exports = __webpack_public_path__ + "static/media/wsymbol_0016_thundery_showers_big_s1.e60ae4e9.png";